var EHDI = EHDI || Object.create(null);

EHDI.scene = EHDI.scene || Object.create(null);

EHDI.scene.TitleScene = function() {
    EHDI.aka.Container.call(this);
}

EHDI.scene.TitleScene.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.scene.TitleScene.prototype.screenWillAppear = function() {
    var bg = new EHDI.aka.Sprite(EHDI.Assets.images['cm_bg']);
 
    this.addChild(bg);
};

EHDI.scene.TitleScene.prototype.screenDidAppear = function() {
    // this.title = new EHDI.aka.PixiText("The Weeds Among The Grass", {fontFamily: 'Exo-Bold', fill: 0xFFFFFF, fontSize : 50});
    
    var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);

    this.cake1 = new EHDI.aka.Sprite(EHDI.Assets.images['cm_title_cake_01']);
        this.cake1.anchor.set(0.5, 0.5);  
        this.cake1.x = 250;
        this.cake1.y = 150;  
    this.cake2 = new EHDI.aka.Sprite(EHDI.Assets.images['cm_title_cake_02']);
        this.cake2.anchor.set(0.5, 0.5); 
        this.cake2.x = 800;
        this.cake2.y = 150;   
    this.cake3 = new EHDI.aka.Sprite(EHDI.Assets.images['cm_title_cake_03']);
        this.cake3.anchor.set(0.5, 0.5);    
        this.cake3.x = 175;
        this.cake3.y = 350;
    this.cake4 = new EHDI.aka.Sprite(EHDI.Assets.images['cm_title_cake_04']);
        this.cake4.anchor.set(0.5, 0.5);    
        this.cake4.x= 900;
        this.cake4.y = 350;
  

    this.addChild(this.cake1);
    this.addChild(this.cake2);
    this.addChild(this.cake3);
    this.addChild(this.cake4);


    this.title = new EHDI.aka.Sprite(EHDI.Assets.images['cm_title_logo']);
    this.title.anchor.set(0.5, 0.5);    
    // this.title.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.5);
    this.title.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.325);
   
    this.addChild(this.title);

    this.sound = new EHDI.displays.ToggleButton(EHDI.Assets.images["btn_audio1"], EHDI.Assets.images["btn_audio3"], EHDI.Assets.images["btn_audio2"], EHDI.Assets.images["btn_audio4"], EHDI.GAME.soundManager.getMuted());
    this.sound.setOnClickFunction(this.toggleAudio);
    this.sound.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.1, EHDI.GAME.sceneManager.getStageHeight() * 0.09);
    
    this.addChild(this.sound);

     this.closeBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_close"], null, null, null,0.8);
  this.closeBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.96, EHDI.GAME.sceneManager.getStageHeight() * 0.09);
  this.closeBtn.setOnClickFunction(function(){
    location.href = "?isGameStarted=false"
  });
  this.addChild(this.closeBtn);
    
    // this.highScoreHolder = new EHDI.components.HighScoreHolder(this, EHDI.GAME.saveData);
    this.highScoreHolder = new EHDI.components.HighScoreHolder(this, cache.highScore);

    this.highScoreHolder.setXY(EHDI.GAME.sceneManager.getStageWidth() * 0.67, EHDI.GAME.sceneManager.getStageHeight() * 0.0417);
    
    
    this.playBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_play"], EHDI.Assets.images["btn_play2"], null, null);
    
    // this.playBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.85);
    this.playBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.875);
    
    this.addChild(this.playBtn);
    
    this.playBtn.setOnClickFunction(this.startGame);
    
    this.playTxt = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("BTN_PLAY"));
    
    this.playTxt.anchor.set(0.75, 0.5);
    
    this.playBtn.addChild(this.playTxt);


    
    var tlPhase2 = function()
    {
        // this.tl.kill();
        // this.tl = null;


        
    this.tl1 = new TimelineMax({repeat: -1, yoyo:true});   
    this.tl2 = new TimelineMax({repeat: -1, yoyo:true});   
    this.tl3 = new TimelineMax({repeat: -1, yoyo:true});   
    this.tl4 = new TimelineMax({repeat: -1, yoyo:true});   
    this.tl1.to(this.cake1, 0.35 + (Math.random() * 0.25), {y: 125 - (Math.random() * 25)});
    this.tl2.to(this.cake2, 0.5 + (Math.random() * 0.25), {y: 125 - (Math.random() * 25)});
    this.tl3.to(this.cake3, 0.45 + (Math.random() * 0.25), {y: 325 - (Math.random() * 25)});
    this.tl4.to(this.cake4, 0.65 + (Math.random() * 0.25), {y: 325 - (Math.random() * 25)});

    }

    this.tl = new TimelineMax({repeat: 0});   


    this.tl1 = new TimelineMax({repeat: 0});   
    this.tl2 = new TimelineMax({repeat: 0});   
    this.tl3 = new TimelineMax({repeat: 0});   
    this.tl4 = new TimelineMax({repeat: 0});   

    this.tl.from(this.title, 1.2, {scaleX:0, scaleY:0, ease: Elastic.easeOut});
    this.tl.from(this.playBtn, 0.25, {scaleX:0, scaleY:0, ease: Back.easeOut});

    this.tl1.from(this.cake1, 0.75, {y: -200, ease:Elastic.easeOut});
    this.tl2.from(this.cake2, 0.75, {y: -200, ease:Elastic.easeOut});
    this.tl3.from(this.cake3, 0.75, {y: -200, ease:Elastic.easeOut});
    this.tl4.from(this.cake4, 0.75, {y: -200, ease:Elastic.easeOut});
    this.tl1.add(tlPhase2.bind(this));

    
    if(!EHDI.GAME.debugUtils) {
        EHDI.GAME.debugUtils = new EHDI.debugUtils.debugUtilsContainer("v0.3.1");
        // EHDI.GAME.sceneManager.addNotification(EHDI.GAME.debugUtils);
    }

        

    if(!EHDI.GAME.bgm)
    {
            EHDI.GAME.soundManager.autoResumeToggle(true);
            EHDI.GAME.bgm = EHDI.GAME.soundManager.playBGM("cakematch");
    }

    
};

EHDI.scene.TitleScene.prototype.toggleAudio = function(enable) {
    EHDI.GAME.soundManager.setMute(enable);
    
    EHDI.GAME.soundManager.playSFX("button_sfx");
    var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
    cache.isMuted = enable;
    EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
}


EHDI.scene.TitleScene.prototype.startGame = function() {
    EHDI.GAME.gameObject = new EHDI.scene.GameScene();
    EHDI.GAME.soundManager.playSFX("button_sfx");
    EHDI.GAME.sceneManager.changeScene(new EHDI.scene.GameScene(), {x : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageWidth(), 0), duration : 0.25});
};

EHDI.scene.TitleScene.prototype.screenDidDisappear = function() {

    
    if(this.tl)
        this.tl.kill();
    this.tl = null;

    if(this.tl1)
        this.tl1.kill();
    this.tl1 = null;

    if(this.tl2)
        this.tl2.kill();
    this.tl2 = null;

    if(this.tl3)
        this.tl3.kill();
    this.tl3 = null;

    if(this.tl4)
        this.tl4.kill();
    this.tl4 = null;
    

    this.destroy({children: true});
    // delete this;
}

